import React from 'react'

import {
  InputAndSubtitle,
  LinkStyled,
  StyledInputContainer,
  StyledLabel,
  SubtitleRowStyled,
  SubtitleTextStyled,
  TextAreaStyled,
  TextInputProps,
  TextInputStyled,
  TextValue,
} from './InputStyles'

const ensureFullUrl = (url: string): string => {
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  return `https://${url}`
}

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (props, ref) => {
    const {
      $label,
      $labelColor,
      $labelLocation,
      $subtitleText,
      $subtitleTextColor,
      mode,
      type = 'input',
    } = props

    return (
      <StyledInputContainer $labelLocation={$labelLocation}>
        {$label && (
          <StyledLabel $labelColor={$labelColor} htmlFor={$label}>
            {$label}
          </StyledLabel>
        )}

        <InputAndSubtitle>
          {mode === 'read' ? (
            type === 'link' ? (
              <LinkStyled
                href={ensureFullUrl(String(props.defaultValue))}
                target='_blank'
                rel='noopener noreferrer'>
                {props.defaultValue}
              </LinkStyled>
            ) : (
              <TextValue>{props.defaultValue}</TextValue>
            )
          ) : type === 'textarea' ? (
            <TextAreaStyled {...props} ref={ref} />
          ) : (
            <TextInputStyled {...props} ref={ref}></TextInputStyled>
          )}
          {mode !== 'read' && $subtitleText && (
            <SubtitleRowStyled>
              <SubtitleTextStyled $subtitleTextColor={$subtitleTextColor}>
                {$subtitleText}
              </SubtitleTextStyled>
            </SubtitleRowStyled>
          )}
        </InputAndSubtitle>
      </StyledInputContainer>
    )
  }
)
TextInput.displayName = 'TextInput'
